import { useEffect } from 'preact/compat'
import { useDispatch } from 'react-redux'
import { updatePayPalStyles } from '../redux/slice/payPalStylesSlice'

export default function usePaypalStyles({
  paypalButtonStyle,
  paypalCreditButtonStyle,
}) {
  const dispatch = useDispatch()

  useEffect(() => {
    const stylesToUpdate = {
      ...(paypalButtonStyle && { payPalButton: paypalButtonStyle }),
      ...(paypalCreditButtonStyle && {
        payPalCreditButton: paypalCreditButtonStyle,
      }),
    }
    dispatch(updatePayPalStyles(stylesToUpdate))
  }, [paypalButtonStyle, paypalCreditButtonStyle])
}
